import { render, staticRenderFns } from "./AddonDetails.vue?vue&type=template&id=ff5fca82&"
import script from "./AddonDetails.vue?vue&type=script&lang=js&"
export * from "./AddonDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports